import { SuggestState } from 'src/state/SuggestState';
import { SUGGEST_ACTIONS, SuggestActions } from 'src/actions/SuggestActions';

export function suggestReducer(
    state: SuggestState,
    action: SuggestActions,
): SuggestState {
    switch (action.type) {
        case SUGGEST_ACTIONS.SUCCESS:
            return {
                ...state,
                suggests: action.data,
            };

        default:
            return state;
    }
}
